var map = {
	"./girafee.jpg": 75715,
	"./girl 2.jpg": 9264,
	"./girl.jpg": 84298,
	"./honey bee.jpg": 23551,
	"./lion 6.jpg": 92160,
	"./rat 2.jpg": 80973,
	"./rat.jpg": 72879,
	"./squarrel.jpg": 32549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93310;